import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useRegrasCalculoContext } from 'pages/RegrasCalculo.context'
import { useParams } from 'react-router-dom'
import { regrasCalculo } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRegraCalculoPage() {
    const { mutateAsync, isLoading } = regrasCalculo.mutations.useSoftDelete({
        invalidateQuery: true,
        onSuccess: () => {
            toast.success('Regra de cálculo excluída com sucesso')
        },
        onError: () => {
            toast.error('Erro ao excluir regra de cálculo')
        },
    })

    const { regrasCalculoId } = useParams()
    const { data } = useRegrasCalculoContext()

    const row = data?.find(item => item.id === +regrasCalculoId!)
    if (!row) return null

    return (
        <ConfirmarExclusao
            permissao={['delete', 'RegrasDeCálculo']}
            loading={isLoading}
            onConfirm={() => mutateAsync(row)}
            title="Deseja realmente excluir esta regra de cálculo?"
        />
    )
}
